var Standard = /** @class */ (function () {
    function Standard(id, name, reference, level, type) {
        this.id = id;
        this.name = name;
        this.reference = reference;
        this.level = level;
        this.type = type;
    }
    return Standard;
}());
export { Standard };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhbmRhcmQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdGFuZGFyZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJQTtJQUNJLGtCQUNXLEVBQVUsRUFDVixJQUFZLEVBQ1osU0FBaUIsRUFDakIsS0FBNEMsRUFDNUMsSUFBa0I7UUFKbEIsT0FBRSxHQUFGLEVBQUUsQ0FBUTtRQUNWLFNBQUksR0FBSixJQUFJLENBQVE7UUFDWixjQUFTLEdBQVQsU0FBUyxDQUFRO1FBQ2pCLFVBQUssR0FBTCxLQUFLLENBQXVDO1FBQzVDLFNBQUksR0FBSixJQUFJLENBQWM7SUFDekIsQ0FBQztJQUNULGVBQUM7QUFBRCxDQUFDLEFBUkQsSUFRQyJ9